import React from "react";
import { Link } from "react-router-dom";

const Reviews = () => {
    return (
<>
<div >
<section id="reviews-section">
      <turbo-frame
        complete=""
        id="listing_reviews_frame"
        loading="lazy"
        src="https://www.circular-couturecollective.com/component_loader/pdp_sections/listing_reviews_frame?listing_id=74496"
        style={{
          opacity: '1'
        }}
        target="_top"
      >
        <div
          className="component product-reviews"
          data-component--product-reviews-component-current-path-value="https://www.circular-couturecollective.com/component_loader/pdp_sections/listing_reviews_frame?listing_id=74496"
          data-controller="component--product-reviews-component"
          id="reviews-section"
        >
          <h2 className="mb-3 pb-3 text-center">
            REVIEWS
          </h2>
          <div className="main-container component header pt-0 m-0">
            <div className="row no-gutters header-tabs">
              <div className="col-6">
                {' '}
                <Link
                  className="tab -active"
                  to="javascript:void(0)"
                >
                  Lender Reviews
                </Link>
              </div>
            </div>
            <div className="item-reviews">
              <div className="item-ratings">
                <div data-component--product-reviews-component-target="stars">
                  <div className="product-ratings-component">
                    <div className="average-rating col-12">
                      <div className="total-rating">
                        <svg
                          height="16px"
                          viewBox="182.483 291.768 20 19.02"
                          width="16px"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g
                            fill="none"
                            stroke="#626262"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            style={{}}
                            transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                          >
                            <path
                              d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                              style={{
                                fill: 'rgb(0, 0, 0)',
                                stroke: 'rgb(0, 0, 0)',
                                strokeWidth: '1.41px'
                              }}
                            >
                            </path>
                          </g>
                        </svg>
                        <svg
                          height="16px"
                          viewBox="182.483 291.768 20 19.02"
                          width="16px"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g
                            fill="none"
                            stroke="#626262"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            style={{}}
                            transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                          >
                            <path
                              d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                              style={{
                                fill: 'rgb(0, 0, 0)',
                                stroke: 'rgb(0, 0, 0)',
                                strokeWidth: '1.41px'
                              }}
                            >
                            </path>
                          </g>
                        </svg>
                        <svg
                          height="16px"
                          viewBox="182.483 291.768 20 19.02"
                          width="16px"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g
                            fill="none"
                            stroke="#626262"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            style={{}}
                            transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                          >
                            <path
                              d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                              style={{
                                fill: 'rgb(0, 0, 0)',
                                stroke: 'rgb(0, 0, 0)',
                                strokeWidth: '1.41px'
                              }}
                            >
                            </path>
                          </g>
                        </svg>
                        <svg
                          height="16px"
                          viewBox="182.483 291.768 20 19.02"
                          width="16px"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g
                            fill="none"
                            stroke="#626262"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            style={{}}
                            transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                          >
                            <path
                              d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                              style={{
                                fill: 'rgb(0, 0, 0)',
                                stroke: 'rgb(0, 0, 0)',
                                strokeWidth: '1.41px'
                              }}
                            >
                            </path>
                          </g>
                        </svg>
                        <svg
                          height="16px"
                          viewBox="182.483 291.768 20 19.02"
                          width="16px"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g
                            fill="none"
                            stroke="#626262"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            style={{}}
                            transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                          >
                            <path
                              d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                              style={{
                                stroke: 'rgb(0, 0, 0)',
                                strokeWidth: '1.41px'
                              }}
                            />
                          </g>
                        </svg>
                        <p>
                          4.9
                        </p>
                      </div>
                      <p className="total-reviews">
                        Based on 311 Reviews
                      </p>
                    </div>
                    <div className="ratings-container">
                      <div
                        className="ratings stars-count"
                        data-rating-value="5"
                      >
                        <div className="star">
                          <svg
                            height="16px"
                            viewBox="182.483 291.768 20 19.02"
                            width="16px"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              fill="none"
                              stroke="#626262"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              style={{}}
                              transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                            >
                              <path
                                d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                style={{
                                  fill: 'rgb(0, 0, 0)',
                                  stroke: 'rgb(0, 0, 0)',
                                  strokeWidth: '1.41px'
                                }}
                              >
                              </path>
                            </g>
                          </svg>
                          <svg
                            height="16px"
                            viewBox="182.483 291.768 20 19.02"
                            width="16px"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              fill="none"
                              stroke="#626262"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              style={{}}
                              transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                            >
                              <path
                                d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                style={{
                                  fill: 'rgb(0, 0, 0)',
                                  stroke: 'rgb(0, 0, 0)',
                                  strokeWidth: '1.41px'
                                }}
                              >
                              </path>
                            </g>
                          </svg>
                          <svg
                            height="16px"
                            viewBox="182.483 291.768 20 19.02"
                            width="16px"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              fill="none"
                              stroke="#626262"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              style={{}}
                              transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                            >
                              <path
                                d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                style={{
                                  fill: 'rgb(0, 0, 0)',
                                  stroke: 'rgb(0, 0, 0)',
                                  strokeWidth: '1.41px'
                                }}
                              >
                              </path>
                            </g>
                          </svg>
                          <svg
                            height="16px"
                            viewBox="182.483 291.768 20 19.02"
                            width="16px"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              fill="none"
                              stroke="#626262"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              style={{}}
                              transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                            >
                              <path
                                d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                style={{
                                  fill: 'rgb(0, 0, 0)',
                                  stroke: 'rgb(0, 0, 0)',
                                  strokeWidth: '1.41px'
                                }}
                              >
                              </path>
                            </g>
                          </svg>
                          <svg
                            height="16px"
                            viewBox="182.483 291.768 20 19.02"
                            width="16px"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              fill="none"
                              stroke="#626262"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              style={{}}
                              transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                            >
                              <path
                                d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                style={{
                                  fill: 'rgb(0, 0, 0)',
                                  stroke: 'rgb(0, 0, 0)',
                                  strokeWidth: '1.41px'
                                }}
                              >
                              </path>
                            </g>
                          </svg>
                        </div>
                        <div className="rating-bar-container">
                          <div
                            className="rating-bar"
                            style={{
                              width: '90%'
                            }}
                          />
                        </div>
                        <div>
                          <p>
                            281
                          </p>
                        </div>
                      </div>
                      <div
                        className="ratings stars-count"
                        data-rating-value="4"
                      >
                        <div className="star">
                          <svg
                            height="16px"
                            viewBox="182.483 291.768 20 19.02"
                            width="16px"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              fill="none"
                              stroke="#626262"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              style={{}}
                              transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                            >
                              <path
                                d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                style={{
                                  fill: 'rgb(0, 0, 0)',
                                  stroke: 'rgb(0, 0, 0)',
                                  strokeWidth: '1.41px'
                                }}
                              >
                              </path>
                            </g>
                          </svg>
                          <svg
                            height="16px"
                            viewBox="182.483 291.768 20 19.02"
                            width="16px"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              fill="none"
                              stroke="#626262"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              style={{}}
                              transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                            >
                              <path
                                d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                style={{
                                  fill: 'rgb(0, 0, 0)',
                                  stroke: 'rgb(0, 0, 0)',
                                  strokeWidth: '1.41px'
                                }}
                              >
                              </path>
                            </g>
                          </svg>
                          <svg
                            height="16px"
                            viewBox="182.483 291.768 20 19.02"
                            width="16px"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              fill="none"
                              stroke="#626262"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              style={{}}
                              transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                            >
                              <path
                                d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                style={{
                                  fill: 'rgb(0, 0, 0)',
                                  stroke: 'rgb(0, 0, 0)',
                                  strokeWidth: '1.41px'
                                }}
                              >
                              </path>
                            </g>
                          </svg>
                          <svg
                            height="16px"
                            viewBox="182.483 291.768 20 19.02"
                            width="16px"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              fill="none"
                              stroke="#626262"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              style={{}}
                              transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                            >
                              <path
                                d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                style={{
                                  fill: 'rgb(0, 0, 0)',
                                  stroke: 'rgb(0, 0, 0)',
                                  strokeWidth: '1.41px'
                                }}
                              >
                              </path>
                            </g>
                          </svg>
                          <svg
                            height="16px"
                            viewBox="182.483 291.768 20 19.02"
                            width="16px"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              fill="none"
                              stroke="#626262"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              style={{}}
                              transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                            >
                              <path
                                d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                style={{
                                  stroke: 'rgb(0, 0, 0)',
                                  strokeWidth: '1.41px'
                                }}
                              >
                              </path>
                            </g>
                          </svg>
                        </div>
                        <div className="rating-bar-container">
                          <div
                            className="rating-bar"
                            style={{
                              width: '9%'
                            }}
                          />
                        </div>
                        <div>
                          <p>
                            29
                          </p>
                        </div>
                      </div>
                      <div
                        className="ratings stars-count"
                        data-rating-value="3"
                      >
                        <div className="star">
                          <svg
                            height="16px"
                            viewBox="182.483 291.768 20 19.02"
                            width="16px"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              fill="none"
                              stroke="#626262"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              style={{}}
                              transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                            >
                              <path
                                d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                style={{
                                  fill: 'rgb(0, 0, 0)',
                                  stroke: 'rgb(0, 0, 0)',
                                  strokeWidth: '1.41px'
                                }}
                              >
                              </path>
                            </g>
                          </svg>
                          <svg
                            height="16px"
                            viewBox="182.483 291.768 20 19.02"
                            width="16px"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              fill="none"
                              stroke="#626262"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              style={{}}
                              transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                            >
                              <path
                                d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                style={{
                                  fill: 'rgb(0, 0, 0)',
                                  stroke: 'rgb(0, 0, 0)',
                                  strokeWidth: '1.41px'
                                }}
                              >
                              </path>
                            </g>
                          </svg>
                          <svg
                            height="16px"
                            viewBox="182.483 291.768 20 19.02"
                            width="16px"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              fill="none"
                              stroke="#626262"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              style={{}}
                              transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                            >
                              <path
                                d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                style={{
                                  fill: 'rgb(0, 0, 0)',
                                  stroke: 'rgb(0, 0, 0)',
                                  strokeWidth: '1.41px'
                                }}
                              >
                              </path>
                            </g>
                          </svg>
                          <svg
                            height="16px"
                            viewBox="182.483 291.768 20 19.02"
                            width="16px"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              fill="none"
                              stroke="#626262"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              style={{}}
                              transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                            >
                              <path
                                d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                style={{
                                  stroke: 'rgb(0, 0, 0)',
                                  strokeWidth: '1.41px'
                                }}
                              >
                              </path>
                            </g>
                          </svg>
                          <svg
                            height="16px"
                            viewBox="182.483 291.768 20 19.02"
                            width="16px"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              fill="none"
                              stroke="#626262"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              style={{}}
                              transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                            >
                              <path
                                d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                style={{
                                  stroke: 'rgb(0, 0, 0)',
                                  strokeWidth: '1.41px'
                                }}
                              >
                              </path>
                            </g>
                          </svg>
                        </div>
                        <div className="rating-bar-container">
                          <div
                            className="rating-bar"
                            style={{
                              width: '0%'
                            }}
                          />
                        </div>
                        <div>
                          <p>
                            1
                          </p>
                        </div>
                      </div>
                      <div
                        className="ratings stars-count"
                        data-rating-value="2"
                      >
                        <div className="star">
                          <svg
                            height="16px"
                            viewBox="182.483 291.768 20 19.02"
                            width="16px"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              fill="none"
                              stroke="#626262"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              style={{}}
                              transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                            >
                              <path
                                d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                style={{
                                  fill: 'rgb(0, 0, 0)',
                                  stroke: 'rgb(0, 0, 0)',
                                  strokeWidth: '1.41px'
                                }}
                              >
                              </path>
                            </g>
                          </svg>
                          <svg
                            height="16px"
                            viewBox="182.483 291.768 20 19.02"
                            width="16px"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              fill="none"
                              stroke="#626262"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              style={{}}
                              transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                            >
                              <path
                                d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                style={{
                                  fill: 'rgb(0, 0, 0)',
                                  stroke: 'rgb(0, 0, 0)',
                                  strokeWidth: '1.41px'
                                }}
                              >
                              </path>
                            </g>
                          </svg>
                          <svg
                            height="16px"
                            viewBox="182.483 291.768 20 19.02"
                            width="16px"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              fill="none"
                              stroke="#626262"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              style={{}}
                              transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                            >
                              <path
                                d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                style={{
                                  stroke: 'rgb(0, 0, 0)',
                                  strokeWidth: '1.41px'
                                }}
                              >
                              </path>
                            </g>
                          </svg>
                          <svg
                            height="16px"
                            viewBox="182.483 291.768 20 19.02"
                            width="16px"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              fill="none"
                              stroke="#626262"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              style={{}}
                              transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                            >
                              <path
                                d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                style={{
                                  stroke: 'rgb(0, 0, 0)',
                                  strokeWidth: '1.41px'
                                }}
                              >
                              </path>
                            </g>
                          </svg>
                          <svg
                            height="16px"
                            viewBox="182.483 291.768 20 19.02"
                            width="16px"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              fill="none"
                              stroke="#626262"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              style={{}}
                              transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                            >
                              <path
                                d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                style={{
                                  stroke: 'rgb(0, 0, 0)',
                                  strokeWidth: '1.41px'
                                }}
                              >
                              </path>
                            </g>
                          </svg>
                        </div>
                        <div className="rating-bar-container">
                          <div
                            className="rating-bar"
                            style={{
                              width: '0%'
                            }}
                          />
                        </div>
                        <div>
                          <p>
                            0
                          </p>
                        </div>
                      </div>
                      <div
                        className="ratings stars-count"
                        data-rating-value="1"
                      >
                        <div className="star">
                          <svg
                            height="16px"
                            viewBox="182.483 291.768 20 19.02"
                            width="16px"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              fill="none"
                              stroke="#626262"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              style={{}}
                              transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                            >
                              <path
                                d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                style={{
                                  fill: 'rgb(0, 0, 0)',
                                  stroke: 'rgb(0, 0, 0)',
                                  strokeWidth: '1.41px'
                                }}
                              >
                              </path>
                            </g>
                          </svg>
                          <svg
                            height="16px"
                            viewBox="182.483 291.768 20 19.02"
                            width="16px"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              fill="none"
                              stroke="#626262"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              style={{}}
                              transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                            >
                              <path
                                d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                style={{
                                  stroke: 'rgb(0, 0, 0)',
                                  strokeWidth: '1.41px'
                                }}
                              >
                              </path>
                            </g>
                          </svg>
                          <svg
                            height="16px"
                            viewBox="182.483 291.768 20 19.02"
                            width="16px"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              fill="none"
                              stroke="#626262"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              style={{}}
                              transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                            >
                              <path
                                d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                style={{
                                  stroke: 'rgb(0, 0, 0)',
                                  strokeWidth: '1.41px'
                                }}
                              >
                              </path>
                            </g>
                          </svg>
                          <svg
                            height="16px"
                            viewBox="182.483 291.768 20 19.02"
                            width="16px"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              fill="none"
                              stroke="#626262"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              style={{}}
                              transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                            >
                              <path
                                d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                style={{
                                  stroke: 'rgb(0, 0, 0)',
                                  strokeWidth: '1.41px'
                                }}
                              >
                              </path>
                            </g>
                          </svg>
                          <svg
                            height="16px"
                            viewBox="182.483 291.768 20 19.02"
                            width="16px"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              fill="none"
                              stroke="#626262"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              style={{}}
                              transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                            >
                              <path
                                d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                style={{
                                  stroke: 'rgb(0, 0, 0)',
                                  strokeWidth: '1.41px'
                                }}
                              >
                              </path>
                            </g>
                          </svg>
                        </div>
                        <div className="rating-bar-container">
                          <div
                            className="rating-bar"
                            style={{
                              width: '0%'
                            }}
                          />
                        </div>
                        <div>
                          <p>
                            0
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="sort-reviews">
                <input
                  data-action="change->component--product-reviews-component#loadReviewsSortBy"
                  data-url-query="https://www.circular-couturecollective.com/listings/the-mini-night-tremors-sequinn-9887/reviews"
                  hidden
                  id="sort-by-field"
                  type="text"
                />
                <div className="sort-dropdown">
                  <div
                    className="component dropdown"
                    data-controller="dropdown"
                    data-dropdown-form-field-target-value="#sort-by-field"
                    data-dropdown-selected-value=""
                  >
                    <button
                      className="select"
                      data-action="dropdown#toggle click@window->dropdown#hide"
                      name="button"
                      type="button"
                    >
                      <div className="selected">
                        {' '}
                        <span data-dropdown-target="selectedValue">
                          Newest
                        </span>
                        {' '}
                        <img
                          alt="An icon of a chevron down"
                          className="arrow"
                          height="18"
                          src="https://res.cloudinary.com/dcaptnlz3/image/asset/chevron-down-9acf8e5e6fabf7cc0445d6dfc56a943c.svg"
                          width="14"
                        />
                      </div>
                    </button>
                    <p className="error-message mt-2 d-none" />
                    <div
                      className="menu hidden"
                      data-dropdown-target="menu"
                    >
                      <div className="option-wrapper">
                        <button
                          className="option"
                          data-action="dropdown#toggle dropdown#select"
                          data-dropdown-option-value="newest"
                        >
                          {' '}Newest{' '}
                        </button>
                        <button
                          className="option"
                          data-action="dropdown#toggle dropdown#select"
                          data-dropdown-option-value="highest"
                        >
                          {' '}Highest{' '}
                        </button>
                        <button
                          className="option"
                          data-action="dropdown#toggle dropdown#select"
                          data-dropdown-option-value="lowest"
                        >
                          {' '}Lowest{' '}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div data-component--product-reviews-component-target="pagination">
                <div className="component review">
                  <div className="row">
                    <div className="col-md-3">
                      <div className="product-renter-component">
                       <div className=" no-gutters product-renter p-0 d-flex align-items-center">
                          {' '}
                          <img
                            className="profile-picture-icon"
                            src="https://res.cloudinary.com/dcaptnlz3/image/asset/c_fill,f_auto,h_118,q_auto,w_118/avatar-default-400b291b4806d585a6e1d5449bab9603.png"
                          />
                          <div className="renter-info">
                            <p className="renter py-2 m-0">
                              {' '}Laura R.{' '}
                            </p>
                            <div className=" no-gutters rating">
                              <div className="star">
                                <svg
                                  height="16px"
                                  viewBox="182.483 291.768 20 19.02"
                                  width="16px"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    fill="none"
                                    stroke="#626262"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    style={{}}
                                    transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                                  >
                                    <path
                                      d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                      style={{
                                        fill: 'rgb(0, 0, 0)',
                                        stroke: 'rgb(0, 0, 0)',
                                        strokeWidth: '1.41px'
                                      }}
                                    >
                                    </path>
                                  </g>
                                </svg>
                                <svg
                                  height="16px"
                                  viewBox="182.483 291.768 20 19.02"
                                  width="16px"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    fill="none"
                                    stroke="#626262"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    style={{}}
                                    transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                                  >
                                    <path
                                      d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                      style={{
                                        fill: 'rgb(0, 0, 0)',
                                        stroke: 'rgb(0, 0, 0)',
                                        strokeWidth: '1.41px'
                                      }}
                                    >
                                    </path>
                                  </g>
                                </svg>
                                <svg
                                  height="16px"
                                  viewBox="182.483 291.768 20 19.02"
                                  width="16px"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    fill="none"
                                    stroke="#626262"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    style={{}}
                                    transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                                  >
                                    <path
                                      d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                      style={{
                                        fill: 'rgb(0, 0, 0)',
                                        stroke: 'rgb(0, 0, 0)',
                                        strokeWidth: '1.41px'
                                      }}
                                    >
                                    </path>
                                  </g>
                                </svg>
                                <svg
                                  height="16px"
                                  viewBox="182.483 291.768 20 19.02"
                                  width="16px"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    fill="none"
                                    stroke="#626262"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    style={{}}
                                    transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                                  >
                                    <path
                                      d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                      style={{
                                        fill: 'rgb(0, 0, 0)',
                                        stroke: 'rgb(0, 0, 0)',
                                        strokeWidth: '1.41px'
                                      }}
                                    >
                                    </path>
                                  </g>
                                </svg>
                                <svg
                                  height="16px"
                                  viewBox="182.483 291.768 20 19.02"
                                  width="16px"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    fill="none"
                                    stroke="#626262"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    style={{}}
                                    transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                                  >
                                    <path
                                      d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                      style={{
                                        fill: 'rgb(0, 0, 0)',
                                        stroke: 'rgb(0, 0, 0)',
                                        strokeWidth: '1.41px'
                                      }}
                                    >
                                    </path>
                                  </g>
                                </svg>
                              </div>
                              <p className="text-center renter">
                                {' '}5{' '}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="product-size">
                          <p>
                            Size rented:
                          </p>
                          <p>
                            UK 8
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-8">
                      <div className="review">
                        <p className="with-comment">
                          {' '}Fab fit gorgeous outfit It was very flattering													Would defo recommend Thank you{' '}
                        </p>
                        <p className="text-review">
                          {' '}1 day{' '}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="component review">
                  <div className="row">
                    <div className="col-md-3">
                      <div className="product-renter-component">
                        <div className=" no-gutters product-renter p-0 d-flex align-items-center">
                          {' '}
                          <img
                            className="profile-picture-icon"
                            src="https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_118,q_auto:best,w_118/jnjktb94t739skd85mm8i4i31pdm"
                          />
                          <div className="renter-info">
                            <p className="renter py-2 m-0">
                              {' '}Elena R.{' '}
                            </p>
                            <div className=" no-gutters rating">
                              <div className="star">
                                <svg
                                  height="16px"
                                  viewBox="182.483 291.768 20 19.02"
                                  width="16px"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    fill="none"
                                    stroke="#626262"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    style={{}}
                                    transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                                  >
                                    <path
                                      d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                      style={{
                                        fill: 'rgb(0, 0, 0)',
                                        stroke: 'rgb(0, 0, 0)',
                                        strokeWidth: '1.41px'
                                      }}
                                    >
                                    </path>
                                  </g>
                                </svg>
                                <svg
                                  height="16px"
                                  viewBox="182.483 291.768 20 19.02"
                                  width="16px"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    fill="none"
                                    stroke="#626262"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    style={{}}
                                    transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                                  >
                                    <path
                                      d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                      style={{
                                        fill: 'rgb(0, 0, 0)',
                                        stroke: 'rgb(0, 0, 0)',
                                        strokeWidth: '1.41px'
                                      }}
                                    >
                                    </path>
                                  </g>
                                </svg>
                                <svg
                                  height="16px"
                                  viewBox="182.483 291.768 20 19.02"
                                  width="16px"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    fill="none"
                                    stroke="#626262"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    style={{}}
                                    transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                                  >
                                    <path
                                      d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                      style={{
                                        fill: 'rgb(0, 0, 0)',
                                        stroke: 'rgb(0, 0, 0)',
                                        strokeWidth: '1.41px'
                                      }}
                                    >
                                    </path>
                                  </g>
                                </svg>
                                <svg
                                  height="16px"
                                  viewBox="182.483 291.768 20 19.02"
                                  width="16px"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    fill="none"
                                    stroke="#626262"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    style={{}}
                                    transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                                  >
                                    <path
                                      d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                      style={{
                                        fill: 'rgb(0, 0, 0)',
                                        stroke: 'rgb(0, 0, 0)',
                                        strokeWidth: '1.41px'
                                      }}
                                    >
                                    </path>
                                  </g>
                                </svg>
                                <svg
                                  height="16px"
                                  viewBox="182.483 291.768 20 19.02"
                                  width="16px"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    fill="none"
                                    stroke="#626262"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    style={{}}
                                    transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                                  >
                                    <path
                                      d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                      style={{
                                        fill: 'rgb(0, 0, 0)',
                                        stroke: 'rgb(0, 0, 0)',
                                        strokeWidth: '1.41px'
                                      }}
                                    >
                                    </path>
                                  </g>
                                </svg>
                              </div>
                              <p className="text-center renter">
                                {' '}5{' '}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="product-size">
                          <p>
                            Size rented:
                          </p>
                          <p>
                            UK 10
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-8">
                      <div className="review">
                        <p className="with-comment">
                          {' '}Beautiful jacket, fit to size and in a great													condition{' '}
                        </p>
                        <p className="text-review">
                          {' '}3 days{' '}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="component review">
                  <div className="row">
                    <div className="col-md-3">
                      <div className="product-renter-component">
                        <div className="d-flex align-items-center no-gutters product-renter p-0">
                          {' '}
                          <img
                            className="profile-picture-icon"
                            src="https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_118,q_auto:best,w_118/xkpak6lks5ufp59wq7x534bnsq4s"
                          />
                          <div className="renter-info">
                            <p className="renter py-2 m-0">
                              {' '}Samantha O.{' '}
                            </p>
                            <div className=" no-gutters rating">
                              <div className="star">
                                <svg
                                  height="16px"
                                  viewBox="182.483 291.768 20 19.02"
                                  width="16px"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    fill="none"
                                    stroke="#626262"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    style={{}}
                                    transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                                  >
                                    <path
                                      d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                      style={{
                                        fill: 'rgb(0, 0, 0)',
                                        stroke: 'rgb(0, 0, 0)',
                                        strokeWidth: '1.41px'
                                      }}
                                    >
                                    </path>
                                  </g>
                                </svg>
                                <svg
                                  height="16px"
                                  viewBox="182.483 291.768 20 19.02"
                                  width="16px"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    fill="none"
                                    stroke="#626262"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    style={{}}
                                    transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                                  >
                                    <path
                                      d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                      style={{
                                        fill: 'rgb(0, 0, 0)',
                                        stroke: 'rgb(0, 0, 0)',
                                        strokeWidth: '1.41px'
                                      }}
                                    >
                                    </path>
                                  </g>
                                </svg>
                                <svg
                                  height="16px"
                                  viewBox="182.483 291.768 20 19.02"
                                  width="16px"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    fill="none"
                                    stroke="#626262"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    style={{}}
                                    transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                                  >
                                    <path
                                      d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                      style={{
                                        fill: 'rgb(0, 0, 0)',
                                        stroke: 'rgb(0, 0, 0)',
                                        strokeWidth: '1.41px'
                                      }}
                                    >
                                    </path>
                                  </g>
                                </svg>
                                <svg
                                  height="16px"
                                  viewBox="182.483 291.768 20 19.02"
                                  width="16px"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    fill="none"
                                    stroke="#626262"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    style={{}}
                                    transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                                  >
                                    <path
                                      d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                      style={{
                                        fill: 'rgb(0, 0, 0)',
                                        stroke: 'rgb(0, 0, 0)',
                                        strokeWidth: '1.41px'
                                      }}
                                    >
                                    </path>
                                  </g>
                                </svg>
                                <svg
                                  height="16px"
                                  viewBox="182.483 291.768 20 19.02"
                                  width="16px"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    fill="none"
                                    stroke="#626262"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    style={{}}
                                    transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                                  >
                                    <path
                                      d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                      style={{
                                        fill: 'rgb(0, 0, 0)',
                                        stroke: 'rgb(0, 0, 0)',
                                        strokeWidth: '1.41px'
                                      }}
                                    >
                                    </path>
                                  </g>
                                </svg>
                              </div>
                              <p className="text-center renter">
                                {' '}5{' '}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="product-size">
                          <p>
                            Size rented:
                          </p>
                          <p>
                            UK 6
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-8">
                      <div className="review">
                        <p className="with-comment">
                          {' '}Unreal condition , it was just amazing and													everyone loved it ! Better than my expectations , styled with a													messyish updo and delicate necklace x{' '}
                        </p>
                        <p className="text-review">
                          {' '}3 days{' '}
                        </p>
                      </div>
                      <div className="image-review">
                        <div className="row no-gutters scrollable">
                          <div data-controller="lightbox">
                            <Link
                              data-lg-id="e78cd339-e354-4c8e-baaf-f13149b20f7e"
                              to="https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_900,q_auto:best,w_600/bbcy1ymq4tabyuzuxqnivlli6ixc"
                            >
                              {' '}
                              <img
                                className="image"
                                src="https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_145,q_auto:best,w_107/bbcy1ymq4tabyuzuxqnivlli6ixc"
                              />
                            </Link>
                          </div>
                        </div>
                        <p className="text-review">
                          + tap images to view larger
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="component review">
                  <div className="row">
                    <div className="col-md-3">
                      <div className="product-renter-component">
                        <div className="d-flex align-items-center no-gutters product-renter p-0">
                          {' '}
                          <img
                            className="profile-picture-icon"
                            src="https://res.cloudinary.com/dcaptnlz3/image/asset/c_fill,f_auto,h_118,q_auto,w_118/avatar-default-400b291b4806d585a6e1d5449bab9603.png"
                          />
                          <div className="renter-info">
                            <p className="renter py-2 m-0">
                              {' '}Isobel G.{' '}
                            </p>
                            <div className=" no-gutters rating">
                              <div className="star">
                                <svg
                                  height="16px"
                                  viewBox="182.483 291.768 20 19.02"
                                  width="16px"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    fill="none"
                                    stroke="#626262"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    style={{}}
                                    transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                                  >
                                    <path
                                      d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                      style={{
                                        fill: 'rgb(0, 0, 0)',
                                        stroke: 'rgb(0, 0, 0)',
                                        strokeWidth: '1.41px'
                                      }}
                                    >
                                    </path>
                                  </g>
                                </svg>
                                <svg
                                  height="16px"
                                  viewBox="182.483 291.768 20 19.02"
                                  width="16px"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    fill="none"
                                    stroke="#626262"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    style={{}}
                                    transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                                  >
                                    <path
                                      d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                      style={{
                                        fill: 'rgb(0, 0, 0)',
                                        stroke: 'rgb(0, 0, 0)',
                                        strokeWidth: '1.41px'
                                      }}
                                    >
                                    </path>
                                  </g>
                                </svg>
                                <svg
                                  height="16px"
                                  viewBox="182.483 291.768 20 19.02"
                                  width="16px"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    fill="none"
                                    stroke="#626262"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    style={{}}
                                    transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                                  >
                                    <path
                                      d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                      style={{
                                        fill: 'rgb(0, 0, 0)',
                                        stroke: 'rgb(0, 0, 0)',
                                        strokeWidth: '1.41px'
                                      }}
                                    >
                                    </path>
                                  </g>
                                </svg>
                                <svg
                                  height="16px"
                                  viewBox="182.483 291.768 20 19.02"
                                  width="16px"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    fill="none"
                                    stroke="#626262"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    style={{}}
                                    transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                                  >
                                    <path
                                      d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                      style={{
                                        fill: 'rgb(0, 0, 0)',
                                        stroke: 'rgb(0, 0, 0)',
                                        strokeWidth: '1.41px'
                                      }}
                                    >
                                    </path>
                                  </g>
                                </svg>
                                <svg
                                  height="16px"
                                  viewBox="182.483 291.768 20 19.02"
                                  width="16px"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    fill="none"
                                    stroke="#626262"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    style={{}}
                                    transform="matrix(0.925642, -0.00095, 0.000942, 0.918325, 181.369186, 290.737701)"
                                  >
                                    <path
                                      d="M12 2l3.09 6.26L22 9.27l-5 4.87l1.18 6.88L12 17.77l-6.18 3.25L7 14.14L2 9.27l6.91-1.01L12 2z"
                                      style={{
                                        fill: 'rgb(0, 0, 0)',
                                        stroke: 'rgb(0, 0, 0)',
                                        strokeWidth: '1.41px'
                                      }}
                                    >
                                    </path>
                                  </g>
                                </svg>
                              </div>
                              <p className="text-center renter">
                                {' '}5{' '}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="product-size">
                          <p>
                            Size rented:
                          </p>
                          <p>
                            UK 8
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-8">
                      <div className="review">
                        <p className="with-comment">
                          {' '}Beautiful dress, came in excellent condition,													faint smell of perfume. Styled with sheer black hosiery and black													pointed toe pumps, hair slicked back{' '}
                        </p>
                        <p className="text-review">
                          {' '}3 days{' '}
                        </p>
                      </div>
                      <div className="image-review">
                        <div className="row no-gutters scrollable">
                          <div data-controller="lightbox">
                            <Link
                              data-lg-id="6f7b7dd4-f950-49e6-8288-a5edac946dac"
                              to="https://res.cloudinary.com/dcaptnlz3/image/upload/c_crop,h_2864,w_1909,x_638,y_950/c_fill,f_webp,h_900,q_auto:best,w_600/clhj7x8tilqlqpnyhejj12fam8l2"
                            >
                              {' '}
                              <img
                                className="image"
                                src="https://res.cloudinary.com/dcaptnlz3/image/upload/c_crop,h_2864,w_1909,x_638,y_950/c_fill,f_webp,h_145,q_auto:best,w_107/clhj7x8tilqlqpnyhejj12fam8l2"
                              />
                            </Link>
                          </div>
                        </div>
                        <p className="text-review">
                          + tap images to view larger
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="component pagination">
                  <nav
                    aria-label="pager"
                    className="pagy-nav"
                    role="navigation"
                  >
                    <ul className="pagination-list">
                      <li className="page-item prev disabled">
                        <Link
                          className="page-link"
                          to="#"
                        >
                          <img src="https://res.cloudinary.com/dcaptnlz3/image/asset/chevron-left-218bf512919cbc55739cb2f87ee19df1.svg" />
                        </Link>
                      </li>
                      <li className="page-item active">
                        <Link
                          className="page-link"
                          to="/component_loader/pdp_sections/listing_reviews_frame?listing_id=74496&page=1&per_page=4"
                        >
                          1
                        </Link>
                      </li>
                      <li className="page-item">
                        <Link
                          className="page-link"
                          to="/component_loader/pdp_sections/listing_reviews_frame?listing_id=74496&page=2&per_page=4"
                          rel="next"
                        >
                          2
                        </Link>
                      </li>
                      <li className="page-item">
                        <Link
                          className="page-link"
                          to="/component_loader/pdp_sections/listing_reviews_frame?listing_id=74496&page=3&per_page=4"
                        >
                          3
                        </Link>
                      </li>
                      <li className="page-item">
                        <Link
                          className="page-link"
                          to="/component_loader/pdp_sections/listing_reviews_frame?listing_id=74496&page=4&per_page=4"
                        >
                          4
                        </Link>
                      </li>
                      <li className="page-item disabled gap">
                        <Link
                          className="page-link"
                          to="#"
                        >
                          ...
                        </Link>
                      </li>
                      <li className="page-item">
                        <Link
                          className="page-link"
                          to="/component_loader/pdp_sections/listing_reviews_frame?listing_id=74496&page=78&per_page=4"
                        >
                          78
                        </Link>
                      </li>
                      <li className="page-item next">
                        <Link
                          aria-label="next"
                          className="page-link"
                          to="/component_loader/pdp_sections/listing_reviews_frame?listing_id=74496&page=2&per_page=4"
                          rel="next"
                        >
                          <img src="https://res.cloudinary.com/dcaptnlz3/image/asset/chevron-right-4d9dc1896a4765e272ce510a3e1d363f.svg" />
                        </Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </turbo-frame>
    </section>
</div>
</>

    )
}
export default Reviews;